import XLSX from 'xlsx';
import {saveAs} from 'file-saver';



export function exportToXlsx(data, filename = null) {
    const today = new Date();
    filename = filename ? filename : `hrcs-registrering-${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}.xlsx`;

    function s2ab(input) {
        const buffer = new ArrayBuffer(input.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i !== input.length; ++i) {
            view[i] = input.charCodeAt(i) & 0xFF;
        }
        return buffer;
    }

    const wbout = XLSX.write(
        {
            SheetNames: [ 'Data' ],
            Sheets: { 'Data': XLSX.utils.json_to_sheet(data) }
        },
        {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary'
        }
    );

    saveAs(new Blob([s2ab(wbout)], { type:"application/octet-stream" }), filename);
}

export function importFromXlsx(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event =>  {
            try {
                const workbook = XLSX.read(event.target.result, {type: 'binary'});
                const data = {};
                for (let sheetName in workbook.Sheets) {
                    data[sheetName] = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    resolve(data[sheetName].map(row => row));
                    return;
                }
            } catch (e) {
                console.error(e);
                reject("Kunne ikke lese fil: " + e.message);
            }
        };
        reader.readAsBinaryString(file);
    });
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/xlsxUtils.js